import React from 'react';
import './footer.less';


const Footer = (props: any) => {
    const count = props.count ? props.count : 0;
    return (
        <footer>
            <div className='footer'>
                <div className='background'>
                </div>
                <div className='footer-content'>
                    <div className='item'>
                        <div className='title'>相关资源</div>
                        <ul>
                            <li><a href={'http://bee.tinper.org/'}>tinper-bee组件库</a></li>
                            <li><a href={'http://tinper.org/mdf'}>MDF模型驱动框架</a></li>
                            <li><a href={'https://github.com/yonui/yonui-ys'}>yonui-ys组件库</a></li>
                            <li><a href={'https://mock.yonyoucloud.com/'}>在线接口管理平台</a></li>
                            <li><a href={'http://tinper.org/dist/cdn/index.html'}>公共静态资源库</a></li>
                        </ul>
                    </div>
                    <div className='item'>
                        <div className='title'>社区</div>
                        <ul>
                            <li><a href={'http://github.com/iuap-design/blog/issues'}>云平台体验技术团队BLOG</a></li>
                        </ul>
                    </div>
                    <div className='item'>
                        <div className='title'>帮助</div>
                        <ul>
                            <li><a href={'http://github.com/tinper-bee'}>组件Github 源码</a></li>
                            <li><a href={'https://github.com/iuap-design/tinper-bee/releases'}>更新记录</a></li>
                            <li><a href={'http://github.com/iuap-design/tinper-bee/issues'}>常见问题</a></li>
                        </ul>
                    </div>
                    <div className='item'>
                        <div className='title'>联系我们</div>
                        <ul>
                            <li>北京市海淀区北清路68号用友产业园</li>
                            <li>guoyff@yonyou.com</li>
                        </ul>
                    </div>
                </div>
                <div className="footer-base-font">
                    <p className="copy-right">Copyright ©2026 用友网络科技股份有限公司版权所有京ICP备05007539号-21京公网安备 11010802021935号</p>
                </div>
            </div>
        </footer>
    );
};
export default Footer;
